import emojiRegex from 'emoji-regex';
export const createPrefixCls = (suffixCls) => {
    return (specCls) => {
        return `kui-${suffixCls}${specCls ? '-' + specCls : ''}`;
    };
};
/**
 * 转化像素值
 */
export const transformPx = (px) => {
    if (typeof px === 'string') {
        if (px.match(/r?em|%|vw|vh$/)) {
            return px;
        }
        else {
            return parseInt(px);
        }
    }
    else {
        return px;
    }
};
/**
 * 首字母大写
 * @param text 字符
 */
export const textCase = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
export const substring = (text, length) => {
    const regex = emojiRegex();
    let emojiIndexs = [];
    let match;
    while ((match = regex.exec(text))) {
        const emoji = match[0];
        emoji && emojiIndexs.push(text.indexOf(emoji));
    }
    emojiIndexs = emojiIndexs.filter((el) => {
        return el < length;
    });
    return text.substring(0, length + emojiIndexs.length);
};
